import React, { useEffect, useRef, useState } from 'react';
import { Container, Typography, CircularProgress, Box } from '@mui/material';
import MiniAppCard from '../components/MiniAppCard';
import axios from 'axios';
import MoreCard from './MoreCard';
import { useParams } from 'react-router-dom';
import HeaderApp from '../components/HeaderApp';
import ScrollApp from '../components/ScrollApp';
import ScrollList from '../components/ScrollList';


import { usePageConfig } from '../App';

import WebApp from "@twa-dev/sdk";
import MovieAppCard from '../components/MovieAppCard';

const Miniapp = () => {
    const [categories, setCategories] = useState({
        "Mais Assistidos": [],
        "Lançamentos": [],
        "Dublados": []
    });
    const { bot } = useParams();
    const pageConfig = usePageConfig();
    const titleHeader = pageConfig.title;
    const [loading, setLoading] = useState(true);
    const [configs, setConfigs] = useState({
        curtaflix: { bot: "curtaflix_bot", app: "curtaflix", owner: "curtaflix" },
        arteflix: { bot: "arteflix_bot", app: "arteflix", owner: "dramastvshop" },
        dramastvshop: { bot: "doramastv_bot", app: "dramastvshop", owner: "dramastvshop" }
    });
    const [movieId, setMovieId] = useState(null);
    const [optionClick, setOptionClick] = useState(null);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [message, setMessage] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState('');
    const [userData, setUserData] = useState("");
    const [user, setUser] = useState({});

    const fetchMovies = async () => {
        try {
            setLoading(true);
            const responses = await Promise.all([
                axios.get(`TopWatched`, { params: { days: 15, limit: 20, bot } }),
                axios.get(`getMoviesNewlyAdded`, { params: { limit: 20 } }),
                axios.get(`TopWatched`, { params: { days: 60, limit: 20, bot } }),
            ]);
            setCategories({
                "Em Alta": responses[0].data.videos,
                "Lançamentos": responses[1].data.videos,
                "Mais Assistidos": responses[2].data.videos
            });
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {


        if (WebApp) {
            WebApp.ready(); // Inicializa o WebApp

            console.log("Telegram WebApp carregado ✅");
            if (WebApp.initDataUnsafe?.user) {

                console.log("Dados do usuário:", WebApp.initDataUnsafe?.user);

                setUserData(JSON.stringify(WebApp.initDataUnsafe?.user, null, 2));
                setUser(WebApp.initDataUnsafe?.user)
            } else {
                setUser({ id: 5331734108 })

            }
        } else {
            console.log("Telegram WebApp não encontrado ❌");
            setUserData("Telegram WebApp não encontrado");
        }
        const init_param = WebApp.initDataUnsafe?.start_param
        const paramsUrl = new URLSearchParams(window.location.search);
        const startappFromUrl = paramsUrl.get('startapp');

        const start_param = init_param || startappFromUrl;

        /* setMovieId(-1002387851098)
            setOptionClick("movie_details") */
        console.log("start_param", start_param)
        if (start_param) {
            console.log("movie_details click. movieId:", start_param);
            setMovieId(start_param)
            setOptionClick("movie_details")
        } else {

            setOptionClick("home");
        }
        fetchMovies();
    }, []);

    useEffect(() => {
        if (movieId && debouncedQuery === "") {
            console.log("debouncedQuery. movieId:", movieId);
            setOptionClick("movie_details")
        } else if (debouncedQuery === "") {
            setOptionClick("home")
        } else {
            setOptionClick("search")
        }
    }, [debouncedQuery, movieId]);

    /* useEffect(() => {
        console.log("optionClick e esse : ", optionClick)
        
        setOptionComponents(getOptionComponents(optionClick))

    }, [optionClick, movieId]); */

    useEffect(() => {
        console.log("foi searchQuery")
        const handler = setTimeout(() => setDebouncedQuery(searchQuery), 1000);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    const handleCategoryClick = (category) => {
        console.log(category);
        setSearchQuery(category);
    };

    const handleMyListClick = () => {
        console.log("my_list click");
        setOptionClick("my_list")
    };

    const getOptionComponents = (option) => {
        console.log("option selected:", option);
        if (option === "my_list") {
            return (<ScrollList loading={loading} config={pageConfig} setLoading={setLoading} setError={setError} debouncedQuery={debouncedQuery} setDebouncedQuery={setDebouncedQuery} searchQuery={searchQuery} />)
        } else if (option === "search") {

            return (<ScrollApp loading={loading} config={pageConfig} setLoading={setLoading} setError={setError} debouncedQuery={debouncedQuery} setDebouncedQuery={setDebouncedQuery} searchQuery={searchQuery} />)

        } else if (option === "home") {
            return (<Box
                sx={{
                    flexGrow: 1,
                    height: 'calc(100vh - 170px)',
                    overflowY: 'auto',
                    '&::-webkit-scrollbar': { display: 'none' },
                    '-ms-overflow-style': 'none',
                    'scrollbar-width': 'none',
                    padding: '10px',
                    marginTop: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {Object.keys(categories).map((category) => (
                    <Box key={category} sx={{
                        mt: 2,
                        paddingLeft: 2
                    }}>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                            {category}
                        </Typography>
                        <Box sx={{
                            display: 'flex',
                            overflowX: 'auto',
                            whiteSpace: 'nowrap',
                            gap: 1,
                            paddingBottom: 2,
                            '&::-webkit-scrollbar': { height: '6px' },
                            '&::-webkit-scrollbar-thumb': { backgroundColor: 'red', borderRadius: '4px' }
                        }}>
                            {categories[category].length > 0 ? (
                                <>
                                    {categories[category].map(movie => (
                                        <Box key={movie.id} sx={{ flex: '0 0 auto', width: 155 }}>
                                            <MiniAppCard bot={pageConfig.bot} movie={movie} />
                                        </Box>
                                    ))}

                                    {/* Card de "Ver Mais" */}
                                    <Box sx={{ flex: '0 0 auto', width: 100 }}>
                                        <MoreCard onClick={() => handleCategoryClick(category)} />
                                    </Box>
                                </>
                            ) : (
                                <Typography color="gray">Nenhum filme encontrado.</Typography>
                            )}
                        </Box>
                    </Box>
                ))}
            </Box>)
        } else if (option === "movie_details") {
            if (!movieId || !user) {
                return <Typography color="gray">Você não está autorizado.</Typography>
            } else {

                console.log("entrou no movieappcard");
                return <MovieAppCard movieId={movieId} userId={user.id} config={pageConfig} setMovieId={setMovieId} />
            }

        }
    };

    /*     const handleNewOrder = () => {
            setMenuOpen(false);
            const url = `https://t.me/${bots[bot]}?start=newOrder`;
            window.location.href = url;
        };
    
        const handleClickSuport = () => {
            setMenuOpen(false);
            const url = `https://t.me/${bots[bot]}?start=help`;
            window.location.href = url;
        }; */


    return (
        <Container sx={{ minHeight: '100vh', padding: 0, backgroundColor: '#141414', color: 'white' }}>
            {/* Barra de Navegação */}

            <HeaderApp setMovieId={setMovieId} handleCategoryClick={handleCategoryClick} handleMyListClick={handleMyListClick} setSearchQuery={setSearchQuery} searchQuery={searchQuery} debouncedQuery={debouncedQuery} title={titleHeader} />

            {/* Exibir Erros */}
            {error && (
                <Typography variant="h6" sx={{ textAlign: 'center', color: 'error.main', mt: 4 }}>
                    Erro: {error}
                </Typography>
            )}
            {optionClick && getOptionComponents(optionClick)}

            {/* Seções Horizontais */}
            {/* debouncedQuery != '' ? (
                <ScrollApp loading={loading} bot={bot} setLoading={setLoading} setError={setError} debouncedQuery={debouncedQuery} setDebouncedQuery={setDebouncedQuery} searchQuery={searchQuery} />
            ) : (
                <Box
                    sx={{
                        flexGrow: 1,
                        height: 'calc(100vh - 170px)',
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': { display: 'none' },
                        '-ms-overflow-style': 'none',
                        'scrollbar-width': 'none',
                        padding: '10px',
                        marginTop: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {Object.keys(categories).map((category) => (
                        <Box key={category} sx={{
                            mt: 2,
                            paddingLeft: 2
                        }}>
                            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                                {category}
                            </Typography>
                            <Box sx={{
                                display: 'flex',
                                overflowX: 'auto',
                                whiteSpace: 'nowrap',
                                gap: 1,
                                paddingBottom: 2,
                                '&::-webkit-scrollbar': { height: '6px' },
                                '&::-webkit-scrollbar-thumb': { backgroundColor: 'red', borderRadius: '4px' }
                            }}>
                                {categories[category].length > 0 ? (
                                    <>
                                        {categories[category].map(movie => (
                                            <Box key={movie.id} sx={{ flex: '0 0 auto', width: 155 }}>
                                                <MiniAppCard bot={bots[bot]} movie={movie} />
                                            </Box>
                                        ))}

                                        <Box sx={{ flex: '0 0 auto', width: 100 }}>
                                            <MoreCard onClick={() => handleCategoryClick(category)} />
                                        </Box>
                                    </>
                                ) : (
                                    <Typography color="gray">Nenhum filme encontrado.</Typography>
                                )}
                            </Box>
                        </Box>
                    ))}
                </Box>
            ) */}

            {/* <Box sx={{ position: 'fixed', bottom: 20, right: 20 }}>
                <TelegramButton phoneNumber={pageConfig.phoneNumber} message={"Olá, gostaria de fazer um pedido!"} />
            </Box> */}
        </Container>
    );
};

export default Miniapp;